import { FaCheck } from 'react-icons/fa6'
import AnimatedSection from '../common/AnimatedSection'
import LeadershipSectionLabel from '../leadership/LeadershipSectionLabel'
import { achievementsOperationalSection } from '../../data/achievementsPageData'

function AchievementsOperationalSection() {
  const { label, titleLine1, titleAccent, description, pillars, focusAreas } =
    achievementsOperationalSection

  return (
    <AnimatedSection className="achievements-operational">
      <div className="container corp-container">
        <header className="achievements-operational__head">
          <LeadershipSectionLabel variant="red">{label}</LeadershipSectionLabel>
          <h2>
            {titleLine1} <span>{titleAccent}</span>
          </h2>
          <p>{description}</p>
        </header>

        <div className="achievements-operational__pillars" role="list">
          {pillars.map((pillar) => (
            <article className="achievements-operational__card" key={pillar.id} role="listitem">
              <span className="achievements-operational__number">{pillar.number}</span>
              <h3>{pillar.title}</h3>
              <span className="achievements-operational__accent" aria-hidden="true" />
              <p>{pillar.description}</p>
              <ul>
                {pillar.points.map((point) => (
                  <li key={point}>
                    <FaCheck aria-hidden="true" />
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>

        <div className="achievements-operational__focus" role="list">
          {focusAreas.map((area) => (
            <article className="achievements-operational__focus-card" key={area.id} role="listitem">
              <h3>{area.title}</h3>
              <p>{area.text}</p>
            </article>
          ))}
        </div>
      </div>
    </AnimatedSection>
  )
}

export default AchievementsOperationalSection
